



























import { Component, Prop } from 'vue-property-decorator';

import FilledButton from '@/components/molecules/FilledButton/FilledButton.vue';
import ProviderConnectionForm, {
  FormData
} from '@/componentsV2/templates/ProviderConnectionForm/ProviderConnectionForm.vue';

import MerchantOauthConnect from '@/utils/merchantoauth';

import RewardsProgramCommon from '../RewardsProgramCommon.vue';
import { IBusinessType } from '@/models/business';
import eventBus from '@/utils/eventBus';
import ModalOptions from '@/components/Modal/ModalOptions';

import InternationalizationService from '@/api/InternationalizationService';
import { IProvider } from '@/models/provider';
import { isBothProvider } from '@/utils/provider';
import SignUpService from '@/api/SingupService';

@Component({
  components: {
    FilledButton,
    ProviderConnectionForm
  }
})
export default class IntroductionPOSSystem extends RewardsProgramCommon {
  @Prop() flowType!: IBusinessType;
  @Prop() showChooseOperation!: boolean;

  internationalizationService = new InternationalizationService();
  signUpService = new SignUpService();

  loading = false;

  get flags() {
    return this.$store.getters['flags/getFlags'];
  }

  get title() {
    if (this.flowType === IBusinessType.INSTORE) {
      return 'Which POS system do you use?';
    }

    return 'Which Platform do you use?';
  }

  get description() {
    if (this.flowType == IBusinessType.INSTORE) {
      return `Connect your Point Of Sale account to receive your branded Coins as payment and to give Loyalty Coins after purchases.`;
    }

    return 'Connect your store platform to continue';
  }

  get businessState() {
    return this.$store.getters['business/getBusinessState'];
  }

  get excludeTypes() {
    return this.flowType === IBusinessType.INSTORE
      ? ['online', 'physical_online']
      : ['physical'];
  }

  filterProviderOptions(provider: IProvider) {
    if (this.flowType === IBusinessType.BOTH)
      return isBothProvider(provider.name);

    return true;
  }

  setFormDataOnStore(formData: FormData) {
    this.$store.dispatch('rewardsProgram/SET_FORM_DATA', {
      posSystem: formData
    });
  }

  handleBack(formData: FormData) {
    this.setFormDataOnStore(formData);

    this.$emit('goToStep', {
      redirectToSlug: this.showChooseOperation
        ? this.ERewardsProgramStepSlug.OPERATION
        : this.ERewardsProgramStepSlug.INTRODUCTION
    });
  }

  openProviderNotifyModal(props: any) {
    eventBus.$emit(
      'openSubModal',
      new ModalOptions(
        ``,
        ``,
        'none',
        true,
        ``,
        ``,
        ``,
        false,
        'newProviderNotifyModal',
        false,
        true,
        true
      ),
      props
    );
  }

  openOtherSelectModal() {
    if (this.flowType === IBusinessType.BOTH) {
      this.openProviderNotifyModal({
        buttonLabel: 'Back to dashboard',
        hasFooterText: false,
        onConfirm: () => {
          eventBus.$emit('closeModal');
        },
        onClose: () => {
          eventBus.$emit('closeModal');
        }
      });
      return;
    }
    this.openProviderNotifyModal({
      buttonLabel: 'Launch in-store rewards',
      hasFooterText: true,
      onConfirm: async () => {
        await this.signUpService.setupRules({
          operationType: 'physical'
        });

        this.$store.dispatch('startGuide/UPDATE_PREFERENCES');
        this.$store.dispatch('startGuide/UPDATE_TASKS');
        this.$store.dispatch(
          'startGuide/FILTER_TASKS_BY_OPERATION',
          'physical'
        );
        this.$router.push('/home');
        eventBus.$emit('closeModal');
      },
      onClose: () => {
        this.$store.dispatch('startGuide/UPDATE_PREFERENCES');
        this.$store.dispatch('startGuide/UPDATE_TASKS');
        this.$router.push('/home');
        eventBus.$emit('closeModal');
      }
    });
  }

  async onOtherSelect({ platformName }: Record<string, any>) {
    this.loading = true;

    let formatPartner = String(platformName).toLowerCase();

    if (this.flowType && this.businessState.type === IBusinessType.BOTH) {
      formatPartner = `${this.flowType}::${formatPartner}`;
    }

    await this.internationalizationService.reportNewIntegration({
      type: 'provider',
      comment: formatPartner
    });

    this.loading = false;
    this.openOtherSelectModal();
  }

  private getSession() {
    const session = JSON.parse(
      localStorage.getItem('@twism:bi-session') || 'null'
    );

    if (!session || session.ts < Date.now() - 1000 * 60 * 15) return null;

    return session.sid;
  }

  handleProviderConnection(formData: Record<string, any>) {
    const { link, links } = formData;

    const params = new URLSearchParams();

    if (link) {
      params.set('shop', link);
    }

    params.set('sid', this.getSession());

    localStorage.setItem('@twism:star-guide-integration', 'true');

    MerchantOauthConnect(links, 'connect', params.toString());
  }

  handleSubmit(formData: FormData) {
    this.setFormDataOnStore(formData);

    if (formData.provider === 'other') {
      this.onOtherSelect(formData);
      return;
    }

    if (formData.provider === 'without') {
      this.$emit('goToStep', {
        redirectToSlug: this.ERewardsProgramStepSlug.REWARD_RATIO
      });
      return;
    }

    this.handleProviderConnection(formData);
  }
}
